import { useEffect } from 'react'

import { useFlag } from '~/hooks/useFlag'
import { dispatchDefaultToast, dispatchErrorToast, dispatchSuccessToast } from '~/store/slices/toasterSlice'
import { registerToastDispatcher, type ToastLevel } from '~/utils/analytics/analyticsToastBridge'

export const useAnalyticsToastDispatcher = () => {
    const isEnabled = useFlag('debug__show_user_events')

    useEffect(() => {
        if (!isEnabled) {
            registerToastDispatcher(null)
            return
        }

        const dispatcher = (msg: string, level: ToastLevel) => {
            switch (level) {
                case 'success':
                    dispatchSuccessToast(msg)
                    break
                case 'error':
                    dispatchErrorToast({ message: msg })
                    break
                default:
                    dispatchDefaultToast(msg)
            }
        }

        registerToastDispatcher(dispatcher)
        return () => registerToastDispatcher(null)
    }, [isEnabled])
}
